import React from "react";
import GenericDetailsPage from "../../../Domain/Components/Functional/GenericDetailsPage/GenericDetailsPage";

function GameSessionDetailsPage(props) {
    return <GenericDetailsPage setLoggedIn={props.setLoggedIn}
                            title={"CampaignOperatorGameConfig Details"}
                            endpoint={"campaign-player-currency-transaction/read"}
                            relations={["campaign_player_currency", "transaction", "campaign_player_currency.campaign", "campaign_player_currency.player_currency", "campaign_player_currency.player_currency.player", "campaign_player_currency.player_currency.currency"]} />
}

export default GameSessionDetailsPage;